/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import ServiceRegistry from "bundle/util/ServiceRegistry";

// The following functions will be removed when AJS fixes issue with legal dialog
function updateZIndex(className, zIndex) {
    try {
        document.getElementsByClassName(className)[0]
            .setAttribute("style", `z-index: ${zIndex} !important`);
    } catch (e) {
        // comments panel not open
    }
}

function enableElementById(id) {
    try {
        document.getElementById(id).disabled = false;
    } catch (e) {
        // id not found
    }
}

function enableElementByAriaLabel(ariaLabel, isDisabled = false) {
    try {
        document.querySelector(`[aria-label='${ariaLabel}']`).disabled = isDisabled;
    } catch (e) {
        // aria label not found
    }
}

// eslint-disable-next-line import/prefer-default-export
export const onLegalDialogClose = () => {
    const appStore = ServiceRegistry.getService("AppStore");
    setTimeout(() => {
        if (appStore.isSizedPreset) {
            ServiceRegistry.getService("HUDService").showHud().then(() => {});
        }
        if (appStore.isInLinePreset) {
            ServiceRegistry.getService("CommandReceiverService").executeCommand({ command: "SHOW_HUD" });
        }
        if (appStore.isFWPreset) {
            updateZIndex("QuickTools__QuickTools___zTRYz", "10000");
            updateZIndex("CommentListContainer__modernPageLevelCommentContainer___RbtGq", "1");
            updateZIndex("ModernEditableTextComponent__modernCommentReplyBoxPosition___Hlyp6", "122");
            updateZIndex("MoreCommentsView__moreDownCommentsModern____f7GZ", "150");
        }
    }, 1000);
    if (appStore.isSizedPreset && appStore.inFullScreen) {
        ["bookmarks", "thumbnails", "PageNumberUIModern", "exitFullScreen", "documentSearch", "change-view-mode"]
            .forEach(enableElementById);
        enableElementByAriaLabel("Go to previous page", appStore.previousPageDisabled);
        enableElementByAriaLabel("Go to next page", appStore.nextPageDisabled);
        enableElementByAriaLabel("Zoom page in", appStore.zoomInDisabled);
        enableElementByAriaLabel("Zoom page out", appStore.zoomOutDisabled);
        enableElementByAriaLabel("More actions");
    }
    appStore.setLegalDialogOpen(false);
};
